import type { FC } from 'react';
import { IconUpload } from '../Icon';
import { BasicModal } from './BasicModal';

export const UploadButton: FC = () => {
  const inRacemapApp = window.navigator.userAgent.includes('RacemapApp');

  if (!inRacemapApp) return null;

  return (
    <BasicModal buttonIcon={<IconUpload />} buttonText="Upload Activity">
      <iframe width="100%" height="432" src={'/upload'} title="Upload" style={{ border: 0 }} />
    </BasicModal>
  );
};
